import clsx from 'clsx'
import { xStack } from '../../patterns/stack'
import { list, listItem, listItemNumber } from './PerilCoverageList.css'

export type CoverageListProps = {
  items: Array<string>
  variant?: 'primary' | 'secondary'
  className?: string
}

export function PerilCoverageList({ items, variant = 'primary', className }: CoverageListProps) {
  if (items.length === 0) return null

  return (
    <ul className={clsx(list[variant], className)}>
      {items.map((item, index) => (
        <li key={item} className={xStack({ alignItems: 'flex-start', gap: 'xs' })}>
          <span className={listItemNumber}>{String(index + 1).padStart(2, '0')}</span>
          <span className={listItem}>{item}</span>
        </li>
      ))}
    </ul>
  )
}
